import { generateQueryKey } from 'query';

const featureKey = 'onboarding';

export const getChangeRequestsQueryKey = (id?: string) => generateQueryKey([featureKey, 'change-requests', { id }]);

export const getOnboardingTourStepsQueryKey = () => generateQueryKey([featureKey, 'tour', 'steps']);
